import { LinkProps, MetaProps, Helmet, Attributes, BodyProps } from "react-helmet-async";
import { NonceUUID } from "./Nonce";
import React, { ReactNode } from "react";

const helmetCSPNonce: MetaProps = {
    name: "csp-nonce",
    content: NonceUUID
}

const HelmetCsp: MetaProps = {
    'http-equiv': "Content-Security-Policy",
    content: `
    default-src 'self' https://*.microsoftonline.com/ https://*.microsoft.com https://*.edp.com.br ${process.env.REACT_APP_ENDPOINT_BASE_API} ${process.env.REACT_APP_REDIRECT_URI} 'nonce-${NonceUUID}';
    script-src 'self' 'nonce-${NonceUUID}';
    style-src 'self' https://fonts.googleapis.com/ 'nonce-${NonceUUID}';
    media-src 'self';
    font-src 'self' https://fonts.gstatic.com/ data:;
    img-src 'self' data:;
    object-src 'none';
    form-action 'none';
    upgrade-insecure-requests;`
    //report-uri ${process.env.REACT_APP_REDIRECT_URI}/Csp;`
}

const HelmetMetaCollection: MetaProps[] = [
    <meta charSet="utf-8" />,
    <meta name="viewport" content="width=device-width, initial-scale=1" />,
    <meta name="description" content="Reunião de diretoria da EDP e suas filiais." />,
    helmetCSPNonce,
    HelmetCsp
];

const HelmetLinkCollection: LinkProps[] = [
    <link rel="icon" href="/favicon.ico" />,
    <link rel="apple-touch-icon" href="/logo192.png" />,
    <link rel="manifest" href="/manifest.json" />,
];

const HelmentBodyProps: BodyProps = {
    nonce: NonceUUID
}

const HelmentStyle: Attributes[] = [
    { "data-fullcalendar": "", nonce: NonceUUID }
]

export const HelmentCacheKey: string = "react-helmet-key";

export const HelmentContext = {}

export const HelmetMetaInformation = (): JSX.Element | ReactNode => <Helmet
    meta={HelmetMetaCollection}
    link={HelmetLinkCollection}
    bodyAttributes={HelmentBodyProps}
    style={HelmentStyle}
    async />